import { EtxeApiSlugs, PropertyApplicationDto, PropertyApplicationId } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { PropertyApplicationsAgentConnector } from './agent/applications-agent.connector';
import { PropertyApplicationsOwnerConnector } from './owner/applications-owner.connector';

export class PropertyApplicationsConnector extends ApiConnector<
  PropertyApplicationDto,
  PropertyApplicationDto,
  PropertyApplicationId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.APPLICATIONS);
  }

  agent = () => new PropertyApplicationsAgentConnector(this.apiCaller, this.apiPrefix, this.slug);
  owner = () => new PropertyApplicationsOwnerConnector(this.apiCaller, this.apiPrefix, this.slug);
}
